// extracted by mini-css-extract-plugin
module.exports = {"generalHeader__headerSidebar":"GeneralHeader_generalHeader__headerSidebar__x1UPa"};